import React from 'react';

const RobotIcon = ({ style = {}, width = '100', color = 'rgb(0,100,255)', viewBox = '0 0 100 100' }) => {
  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g fill={color} stroke="white" strokeWidth="4" strokeLinejoin="round">
        <rect x="36" y="3" width="28" height="24" />
        <rect x="13" y="30" width="13" height="33" />
        <rect x="75" y="30" width="13" height="33" />
        <rect x="26" y="27" width="48" height="50" />
        <rect x="31" y="77" width="15" height="21" />
        <rect x="54" y="77" width="15" height="21" />
      </g>
    </svg>
  );
};

export default RobotIcon;
